(function() { window.GUID_b82b8347_a742_4da8_aec1_c25d034fc8ef = { getGuid: function() { return "b82b8347-a742-4da8-aec1-c25d034fc8ef"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class MatchCardHistoryLogger extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            constructor(controlId, ...params) {
                super(controlId, ...params);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.matchId = params[1];
                this.loggingLevel = params[2];
                this.loadHistory = params[3];
            }
            OnControlRendered() {
                try {
                    this.$Control.trigger(`ready`);
                }
                catch (error) {
                    console.error("Error in OnControlRendered", error);
                }
            }
            OnBindEvents() {
                try {
                    CS.Helper.log("MatchCardHistoryLogger", "Binding events...");
                    this.bindHistoryViewerEvents();
                    this.bindMatchCardEvents();
                    CS.Helper.log("MatchCardHistoryLogger", `Successfully bound events`);
                }
                catch (error) {
                    console.error("Error while binding to match card events", error);
                }
            }
            bindHistoryViewerEvents() {
                try {
                    CS.Helper.log("MatchCardHistoryLogger", "Binding to history viewer events...");
                    if (!this.loadHistory) {
                        CS.Helper.log("MatchCardHistoryLogger", "Not loading history, skipping binding to history viewer events");
                        return;
                    }
                    this.$Control.offon(`historyViewerReady.${this.ControlId}`, this.onHistoryViewerReady.bind(this));
                    CS.Helper.log("MatchCardHistoryLogger", "Successfully bound to history viewer events");
                }
                catch (error) {
                    console.error("Error while binding to history viewer events", error);
                }
            }
            onHistoryViewerReady(event, mostRecentItemMarkup) {
                try {
                    CS.Helper.log("MatchCardHistoryLogger", "History viewer loaded");
                    if (!mostRecentItemMarkup) {
                        CS.Helper.log("MatchCardHistoryLogger", "No history to log");
                        return;
                    }
                    CS.Helper.log("MatchCardHistoryLogger", "Enqueuing the logging of the most recent history item");
                    this.enqueue(this.logMarkup.bind(this, mostRecentItemMarkup, true));
                }
                catch (error) {
                    console.error("Error in onHistoryViewerLoaded", error);
                }
            }
            bindMatchCardEvents() {
                try {
                    CS.Helper.log("MatchCardHistoryLogger", "Binding to match card events...");
                    this.matchCard = this.getCurrentMatchCard();
                    if (!this.matchCard) {
                        CS.Helper.log("MatchCardHistoryLogger", "Match card not found");
                    }
                    this.matchCard.$MatchCard.offon(`matchCardChanged.${this.ControlId}`, this.onMatchCardChanged.bind(this));
                    CS.Helper.log("MatchCardHistoryLogger", "Successfully bound to match card events");
                }
                catch (error) {
                    console.error("Error while binding to match card events", error);
                }
            }
            OnDispose() { }
            getCurrentMatchCard() {
                try {
                    return CS.Views.MatchCard.CurrentView;
                }
                catch (error) {
                    console.error("Error while getting parent match card", error);
                }
            }
            onMatchCardChanged(event, response) {
                try {
                    if (this.shouldLog(response)) {
                        this.enqueue(this.logChange.bind(this, response));
                    }
                }
                catch (error) {
                    console.error("Error in onLiveValueChange", error);
                }
            }
            shouldLog(response) {
                try {
                    if (!response ||
                        !response.newItemMarkup ||
                        CS.Helper.isNullOrWhiteSpace(response.newItemMarkup)) {
                        return false;
                    }
                    return true;
                }
                catch (error) {
                    console.error("Error while checking if should log", error);
                    return false;
                }
            }
            enqueue(promise) {
                try {
                    if (!this.queue) {
                        this.queue = Promise.resolve();
                    }
                    this.queue = this.queue.then(promise);
                }
                catch (error) {
                    console.error("Error while enqueuing promise", error);
                }
            }
            logMarkup(markup, preventAddToHistory = false) {
                return new Promise((resolve, reject) => {
                    try {
                        CS.Helper.log("MatchCardHistoryLogger", "Logging message...");
                        const uuid = CS.Helper.generateRandomId();
                        const snackbarId = `match-card-history-logger-${uuid}`;
                        const decodedMarkup = CS.Helper.decodeHTMLEntities(markup);
                        Controls.Snackbar.Show({
                            Id: snackbarId,
                            Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                            Animation: CS.Enumeration.SnackbarAnimation.Slide,
                            Type: CS.Enumeration.SnackbarType.Warning,
                            AutoHideDuration: 5000,
                            Message: decodedMarkup,
                            ReloadOnClose: false,
                        }, true);
                        if (!preventAddToHistory) {
                            this.addItemMarkupToHistoryViewer(decodedMarkup);
                        }
                        CS.Helper.log("MatchCardHistoryLogger", "Successfully logged message");
                        resolve();
                    }
                    catch (error) {
                        reject(error);
                    }
                });
            }
            addItemMarkupToHistoryViewer(markup) {
                try {
                    CS.Helper.log("MatchCardHistoryLogger", "Adding item markup to history viewer...");
                    const $historyViewer = this.$Control.find(".cs-match-card-history-viewer");
                    if (!$historyViewer.length) {
                        CS.Helper.log("MatchCardHistoryLogger", "History viewer not found, skipping adding item markup");
                        return;
                    }
                    const historyViewer = Controls.GetInstance(Controls.MatchCardHistoryViewer, $historyViewer, true);
                    if (!historyViewer) {
                        throw new Error("History viewer not found");
                    }
                    historyViewer.addItem(markup);
                }
                catch (error) {
                    console.error("Error while adding item markup to history viewer", error);
                }
            }
            logChange(response) {
                return new Promise((resolve, reject) => {
                    try {
                        this.logMarkup(response.newItemMarkup).then(resolve).catch(reject);
                    }
                    catch (error) {
                        reject(error);
                    }
                });
            }
        }
        Controls.MatchCardHistoryLogger = MatchCardHistoryLogger;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=match-card-history-logger.js.map
